import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs';
import { WebAngularSharedDataAccessFeatureFlagApisService } from '../services/feature-flags.service';
import * as i0 from "@angular/core";
import * as i1 from "../services/feature-flags.service";
import * as i2 from "@angular/router";
const FEATURE_FLAG_GUARD_DATA_PROPERTY = 'featureFlagGuard';
/**
 * A Guard that actives a route based on if a feature flag value is true
 * Use the data property of the route to define the required feature
 * https://stackoverflow.com/a/42721468
 *
 * @example
 *  const routes: Routes = [{
      path: '',
      component: SomeComponent,
      data: {
        featureFlagGuard: {flagname: 'some_flagname'}
      },
      canActivate: [WebAngularSharedDataAccessFeatureFlagApiGuard]
 *  }];
 * @export
 * @class WebAngularSharedDataAccessFeatureFlagApiGuard
 * @implements {CanActivate}
 */
export class WebAngularSharedDataAccessFeatureFlagApiGuard {
    constructor(featureFlagsService, router) {
        this.featureFlagsService = featureFlagsService;
        this.router = router;
    }
    canActivate(route) {
        const options = route.data[FEATURE_FLAG_GUARD_DATA_PROPERTY];
        return this.featureFlagsService.getFlagAsync(options.flagname).pipe(tap(allowed => {
            if (!allowed && !this.router.navigated) {
                // If we haven't navigated yet, this is a deeplink. Redirect to base
                // if we have navigated, just don't allow this navigation (ie. do nothing)
                this.router.navigate(['/']);
            }
        }));
    }
    static { this.ɵfac = function WebAngularSharedDataAccessFeatureFlagApiGuard_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || WebAngularSharedDataAccessFeatureFlagApiGuard)(i0.ɵɵinject(i1.WebAngularSharedDataAccessFeatureFlagApisService), i0.ɵɵinject(i2.Router)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: WebAngularSharedDataAccessFeatureFlagApiGuard, factory: WebAngularSharedDataAccessFeatureFlagApiGuard.ɵfac }); }
}
//# sourceMappingURL=feature-flag.guard.js.map